import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/navigation'
import { getProfileHeader } from '../../api/auth'
import { getUserNotiHeader } from '../../api/login'
import { useAppContext } from '../../components/provider/AppProvider'
import '../../css/Member.css'
import { handlePostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import { getParsedLocalStorageItem } from '../../js/script'
import { imgURL } from '../Home'

export default function SignUpCompleted({ closeModal }: any) {
  const [item, setItem] = useState<any>()
  const [policy, setPolicy] = useState<any>()
  const { isAppView } = useAppContext()
  // body 스크롤 제어
  const navigate = useNavigate()

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useEffect(() => {
    const token = getParsedLocalStorageItem('accessToken')
    const aboutFishing = getParsedLocalStorageItem('aboutAccessToken')
    getUserNotiHeader(aboutFishing).then((res) => {
      setPolicy(res.data)
    })
    getProfileHeader(token).then((res) => {
      setItem(res.data)
    })
  }, [])

  useEffect(() => {
    //@ts-ignore
    if (window.wcs) {
      //@ts-ignore
      if (!wcs_add) var wcs_add = {}
      //@ts-ignore
      wcs_add['wa'] = 's_b120b5fd14f'
      const _conv = {}
      //@ts-ignore
      _conv.type = 'sign_up'
      //@ts-ignore
      wcs.trans(_conv)
      //@ts-ignore
    }
  }, [])

  useEffect(() => {
    if (item && policy) {
      const signUpComplete: DataLayerArgs = {
        dataLayer: {
          event: 'sign_up',
          event_info: {
            method: 'general',
          }, // ecommerce 이벤트 중 상품보기 단계
          user_info: {
            login_status: 'Y',
            user_id: item?.memberId,
            sign_up_date: item?.joinYmdt,
            marketing_consent_status: policy?.isMarketing,
            push_consent_status: policy?.isBasic,
            sms_consent_status: item?.smsAgreed,
            ems_consent_status: item?.directMailAgreed,
            member_grade: item?.memberGradeName,
          },
        },
      }
      if (isAppView) {
        sendSetAppsflyerEvent({
          eventName: 'sign_up',
          eventType: {
            method: 'general',
            login_status: 'Y',
            user_id: item?.memberId,
            sign_up_date: item?.joinYmdt,
            marketing_consent_status: policy?.isMarketing,
            push_consent_status: policy?.isBasic,
            sms_consent_status: item?.smsAgreed,
            ems_consent_status: item?.directMailAgreed,
            member_grade: item?.memberGradeName,
          },
        })
      } else {
        TagManager.dataLayer(signUpComplete)
      }
    }
  }, [item, policy])

  useEffect(() => {
    // registerComplete(isMobile ? 'mobile' : 'pc');
    handlePostMessage({ actionType: 'registerComplete', params: { mobile: isMobile ? 'mobile' : 'pc' } })
  }, [])

  useEffect(() => {
    window.AF('pba', 'event', {
      eventType: 'EVENT',
      eventName: 'shop_join_done',
    })
  }, [])

  return (
    <>
      <div className='sign_up'>
        <h1>회원가입 완료!</h1>
        <div className='sign_up_contents'>
          <div className='circle'>
            <img src={`${imgURL}/img_sign_up_circle.png`} alt='피싱코인 3,000c, 적립금 30,000원' />
          </div>
          <h2>
            즉시 사용 가능한
            <br />
            웰컴 기프트가 도착했어요!
          </h2>
        </div>
        <p>
          아래 시작하기 버튼을 눌러
          <br />
          웰컴 기프트를 받아 보세요!
        </p>
        <div className='bottom_button'>
          <a
            href='#'
            onClick={(e) => {
              e.preventDefault()
              navigate('/')
              window.location.reload()
              closeModal()
            }}
          >
            시작하기
          </a>
        </div>
      </div>
    </>
  )
}
